import isAfter from 'date-fns/is_after';
import addDays from 'date-fns/add_days';
import format from 'date-fns/format';
import { getI18nConsts, getI18nDefaultFormat } from './i18n';

export default (date, locale = 'en_us', inclusive = true, inWords = true, globalMessages) => {
  const { expires, expired, custom_locale_date: customLocaleDate } = globalMessages;
  const localeDOW = customLocaleDate || locale;

  const {
    dateLocale,
    dateFormat = 'DD-MM-YYYY',
    dateFormatReadable = 'dddd DD/MM',
  } = getI18nConsts(getI18nDefaultFormat(localeDOW));

  const expirationDate = inclusive ? addDays(date, 1) : date;

  const expiresOrExpired = isAfter(expirationDate, new Date()) ? expires : expired;

  const readableExpiration = format(expirationDate, dateFormatReadable, { locale: dateLocale });

  const expiration = format(expirationDate, dateFormat);

  return inWords ? `${expiresOrExpired} ${readableExpiration}` : expiration;
};
